<template>
  <div class="relative">
    <el-input
      id="search"
      v-model="pinStore.searchTerm"
      placeholder="PIN Search..."
      @keydown.enter.prevent="selectTopEntry"
      style="z-index: 1"
    />

    <!-- Results showing div -->
    <div class="absolute top-0 left-0 mt-[-40px] w-[300px] z-10">
      <span v-if="pinStore.searchPins.length > 0">
        Showing {{ pinStore.searchPins.length }} of
        {{ pinStore.totalPins }} PINs
      </span>
      <span v-else-if="pinStore.searchTerm.length > 0">
        No results found...
      </span>
    </div>

    <!-- Dropdown table -->
    <div
      v-if="pinStore.searchPins.length > 0"
      class="absolute top-full bg-black bg-opacity-60 border border-gray-300 dropdown-table rounded-md shadow-md overflow-y-auto max-h-[300px] z-10 w-full"
      v-click-outside="closeDropdown"
    >
      <el-table
        :data="pinStore.searchPins"
        @row-click="handlePinSelect"
        class="cursor-pointer"
      >
        <el-table-column prop="pin" align="center" />
      </el-table>
    </div>
  </div>
</template>

<script setup>
import { usePinStore } from "@/stores/pinStore";
import { onMounted } from "vue";

const props = defineProps({
  onPinGrab: {
    type: Function,
    required: true,
  },
});

const pinStore = usePinStore();

onMounted(async () => {
  await pinStore.initializePins();
});

async function handlePinSelect(row) {
  await pinStore.selectPin(row.pin);
  props.onPinGrab();
}

function selectTopEntry() {
  if (pinStore.searchPins.length > 0) {
    handlePinSelect(pinStore.searchPins[0]);
  }
}

const closeDropdown = () => {
  pinStore.clearSearch();
};
</script>

<style>
.dropdown-table :deep(.el-table__body-wrapper tbody tr:first-child) {
  background-color: #007bff;
  color: white;
}
</style>
